import React, { useState } from "react";
import { motion } from "framer-motion";
import Slider from "react-slick";

// ✅ IMPORT IMAGES
import tambo from "../assets/tambo.jpg";
import pilanesburg from "../assets/pilanesburg.png";
import lanseria from "../assets/lanseria.jpg";
import capeTown from "../assets/cape-town.jpg";
import sunCity from "../assets/sun-city.jpg";
import durban from "../assets/durban.jpg";
import corporate from "../assets/coporate.png";
import corporate1 from "../assets/coporate1.png";
import corporate2 from "../assets/coporate2.png";
import corporate3 from "../assets/coporate3.png";
import image11 from "../assets/image11.png";
import groupPhoto from "../assets/group-photo2.jpg";

// ✅ REPLACE IMAGE PATHS WITH IMPORTS
const services = [
  { 
    title: "Airport Transfers", 
    description: "Seamless and reliable transportation to and from airports, ensuring you arrive on time and in style.",
    images: [tambo, pilanesburg, lanseria]
  },
  { 
    title: "Countrywide Transportation", 
    description: "Comprehensive travel solutions across the country, tailored for comfort and efficiency.",
    images: [capeTown, sunCity, durban]
  },
  { 
    title: "Corporate Travel", 
    description: "Professional transportation for business needs, ensuring punctuality and professionalism.",
    images: [corporate, corporate1, corporate2]
  },
  { 
    title: "Chauffeur Service", 
    description: "Luxury chauffeur-driven rides for a personalized and safe travel experience.",
    images: [corporate3]
  },
  { 
    title: "Special Event Hire", 
    description: "Premium vehicle hire for events, making your special occasions unforgettable.",
    images: [image11]
  },
  { 
    title: "Executive Travel", 
    description: "High-end travel solutions for executives, combining luxury and reliability.",
    images: [groupPhoto]
  }
];

export default function Services() {
  const [hoveredIndex, setHoveredIndex] = useState(null);

  const sliderSettings = {
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3000,
    fade: false,
    arrows: true,
    nextArrow: <CustomNextArrow />,
    prevArrow: <CustomPrevArrow />,
    appendDots: (dots) => (
      <div className="custom-dots">
        <ul style={{ margin: "0px" }}>{dots}</ul>
      </div>
    ),
    customPaging: () => (
      <button className="dot"></button>
    ),
  };

  function CustomNextArrow(props) {
    const { className, style, onClick } = props;
    return (
      <div className={`${className} custom-arrow next`} style={{ ...style, display: "block" }} onClick={onClick}>
        <span>›</span>
      </div>
    );
  }

  function CustomPrevArrow(props) {
    const { className, style, onClick } = props;
    return (
      <div className={`${className} custom-arrow prev`} style={{ ...style, display: "block" }} onClick={onClick}>
        <span>‹</span>
      </div>
    );
  }

  return (
    <section className="services-section">
      <motion.h2 className="services-title" initial={{ opacity: 0, y: -50 }} whileInView={{ opacity: 1, y: 0 }} transition={{ duration: 0.8 }} viewport={{}}>
        OUR SERVICE OFFERING
      </motion.h2>

      <motion.p className="services-subtitle" initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} transition={{ duration: 0.8, delay: 0.2 }} viewport={{}}>
        Discover Our Premium Transportation Solutions
      </motion.p>

      <div className="services-grid">
        {services.map((service, index) => (
          <motion.div key={index} className="service-card" initial={{ opacity: 0 }} whileInView={{ opacity: 1 }} transition={{ duration: 0.8 }} viewport={{}}>
            <div className="card-content">
              <h3 className="service-title">{service.title}</h3>
              <p className="service-description">{service.description}</p>

              <div className={`image-container ${service.images.length > 1 ? 'carousel' : 'single'}`}>
                {service.images.length > 1 ? (
                  <Slider {...sliderSettings}>
                    {service.images.map((image, idx) => (
                      <div key={idx} className="image-slide">
                        <motion.img
                          src={image}
                          alt={`${service.title} ${idx + 1}`}
                          className="service-image"
                          onMouseEnter={() => setHoveredIndex(idx)}
                          onMouseLeave={() => setHoveredIndex(null)}
                          initial={{ opacity: 1 }}
                          animate={{ opacity: hoveredIndex === idx ? 0.7 : 1 }}
                          transition={{ duration: 0.3 }}
                        />

                        {hoveredIndex === idx && idx < service.images.length - 1 && (
                          <motion.div className="next-image-preview">
                            <img
                              src={service.images[(idx + 1) % service.images.length]}
                              alt={`${service.title} ${idx + 2}`}
                              className="preview-image"
                            />
                          </motion.div>
                        )}
                      </div>
                    ))}
                  </Slider>
                ) : (
                  <div className="single-image">
                    <img
                      src={service.images[0]}
                      alt={`${service.title} 1`}
                      className="single-service-image"
                    />
                  </div>
                )}
              </div>
            </div>
          </motion.div>
        ))}
      </div>
    </section>
  );
}